'use client'

import { useEffect } from 'react'
import { captureDeadLinkHit } from '@lib/dead-link-telemetry'

/**
 * Fires once per 404. Mounted in both `not-found.tsx` pages, which are
 * Server Components, so the capture call lives in this small client child
 * instead — same split as `PostHogIdentify`.
 */
export function DeadLinkTracker() {
  useEffect(() => {
    captureDeadLinkHit(window.location.href, document.referrer)
  }, [])

  return null
}
